import { useState, useEffect } from 'react';
import cn from 'classnames';
import { useUpdateAccountInfo } from 'hooks';
import SalonsList from 'components/salonsList';
import { getSelectedSalonNo, getStorageCustomerSalonName } from 'lib/shopify';
import PasswordValidator from 'password-validator';
import DeleteAccount from './deleteAccount';
import styles from './personalInfo.module.scss';

const PersonalInfo = ({
  locale,
  customer,
  accountpagenavigation,
  personalinfoaccountpage,
  secondpersonalinfoaccountpage,
  thirdpersonalinfoaccountpage,
  checkout,
  salonselector,
  registermessages,
}) => {
  const { navigationPersonalInfo } = accountpagenavigation;

  const {
    firstNameField,
    lastNameField,
    emailField,
    userPhoneField,
    passwordField,
    saveChangesButtonContent,
    passwordResetTitleContent,
    currentPasswordFieldContent,
    newPasswordField,
    passwordConfirmationField,
  } = personalinfoaccountpage;
  const {
    passwordCaptionContent,
    updatePasswordButtonContent,
    salonSectionTitle,
    selectedSalonContent,
    noSelectedSalonContent,
    changePreferenceButton,
    deleteAccountTitle,
    deleteAccountContent,
    deleteAccountButton,
    savingChangesButtonContent,
    updatingPasswordButtonContent,
  } = secondpersonalinfoaccountpage;

  const { passwordsDontMatch } = registermessages;

  const { phoneTemplateContent } = thirdpersonalinfoaccountpage;

  const [selectedSalon, setSelectedSalon] = useState({});
  const [updateAccountInfo, { loading, response, error }] = useUpdateAccountInfo();
  const [firstName, setFirstName] = useState(customer.firstName || '');
  const [lastName, setLastName] = useState(customer.lastName || '');
  const [email, setEmail] = useState(customer.email || '');
  const [phone, setPhone] = useState(customer?.phone || '');
  const [passwordField1, setPasswordField1] = useState('');
  const [passwordField2, setPasswordField2] = useState('');
  const [passwordField3, setPasswordField3] = useState('');
  const [passwordField4, setPasswordField4] = useState('');
  const [toggleDeleteAccount, setToggleDeleteAccount] = useState(false);
  const [buttonTracker1, setButtonTracker1] = useState(false);
  const [buttonTracker2, setButtonTracker2] = useState(false);
  const defaultFieldErrors = {
    passwordConfirm: false,
  };
  const [fieldErrors, setFieldErrors] = useState(defaultFieldErrors);

  const checkFields = () => {
    const newFieldErrors = { ...defaultFieldErrors };

    const schema = new PasswordValidator();
    schema.is().min(8).is().max(100).has().lowercase().has().uppercase();

    if (passwordField3 !== passwordField4) {
      newFieldErrors.passwordConfirm = passwordsDontMatch.text;
    }

    setFieldErrors(newFieldErrors);
  };

  useEffect(() => {
    const checkSalonNo = getSelectedSalonNo(locale);
    const checkSalonName = getStorageCustomerSalonName(locale);
    // const fetchSalon = async () => {
    //   const salonRes = await fetch('/api/firebase/get-salon', {
    //     method: 'POST',
    //     headers: {
    //       'Access-Control-Allow-Headers': 'Content-Type',
    //       'Access-Control-Allow-Origin': '*',
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({ salonNo: checkSalonNo }),
    //   });
    //   const { data: salon } = await salonRes.json();
    //
    //   const countryLocale = getLocaleByCountry(salon?.country);
    //
    //   if (countryLocale === locale) {
    //     setSelectedSalon({ salonNo: checkSalonNo, salonName: checkSalonName });
    //   }
    // };

    if (checkSalonNo && checkSalonName) {
      setSelectedSalon({ salonNo: checkSalonNo, salonName: checkSalonName });
    }
  }, [locale]);

  const handleSubmit = async e => {
    e.preventDefault();

    setButtonTracker1(true);
    setButtonTracker2(false);
    await updateAccountInfo(customer.customerAccessToken, {
      firstName,
      lastName,
      email,
      phone,
      password: passwordField1,
    });
    setPasswordField1('');
  };

  const handleReset = async e => {
    e.preventDefault();
    checkFields();
    if (passwordField3 && passwordField4 && passwordField3 === passwordField4) {
      setButtonTracker2(true);
      setButtonTracker1(false);
      await updateAccountInfo(customer.customerAccessToken, {
        email,
        password: passwordField3,
      });
      setPasswordField2('');
      setPasswordField3('');
      setPasswordField4('');
    }
  };

  return (
    <>
      {!toggleDeleteAccount && (
        <>
          <h1 className={styles.title}>{navigationPersonalInfo?.text}</h1>
          <div className={styles.updateSection}>
            <div className={styles.section1}>
              <div className={styles.form1}>
                <h2 className={styles.secondaryTitle}>{navigationPersonalInfo?.text}</h2>
                <form onSubmit={e => handleSubmit(e)}>
                  <label htmlFor="firstName" className={styles.labels}>
                    {firstNameField?.text}*
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    required
                    onChange={e => setFirstName(e.target.value)}
                    className={styles.updateInput}
                    value={firstName}
                  />
                  <label htmlFor="lastName" className={styles.labels}>
                    {lastNameField?.text}*
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    type="text"
                    required
                    onChange={e => setLastName(e.target.value)}
                    className={styles.updateInput}
                    value={lastName}
                  />
                  <label htmlFor="email" className={styles.labels}>
                    {emailField?.text}*
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    onChange={e => setEmail(e.target.value)}
                    className={styles.updateInput}
                    value={email}
                  />
                  <label htmlFor="phone" className={styles.labels}>
                    {userPhoneField?.text}
                  </label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    // pattern="^[+]?[0-9]{9,12}$"
                    placeholder={userPhoneField?.text}
                    onChange={e => setPhone(e.target.value)}
                    className={styles.updateInput}
                    value={phone}
                  />
                  {error && error.field?.includes('phone') && (
                    <div className={styles.phoneTemplate}>
                      <p>{phoneTemplateContent?.text}</p>
                    </div>
                  )}
                  <div className={styles.labels}>{passwordField?.text}*</div>
                  <input
                    name="password"
                    onChange={e => setPasswordField1(e.target.value)}
                    type="password"
                    required
                    placeholder={passwordField?.text}
                    className={styles.updateInput}
                    value={passwordField1}
                  />

                  <button className={styles.submitButton} type="submit">
                    {buttonTracker1 && (loading || response === false)
                      ? `${savingChangesButtonContent?.text}`
                      : `${saveChangesButtonContent?.text}`}
                  </button>
                  {/* )} */}
                  {error && buttonTracker1 && (
                    <div className={styles.mt1}>
                      <span role="img" aria-label="error">
                        ⚠️
                      </span>
                      : {error.message}
                    </div>
                  )}
                </form>
              </div>

              <div className={styles.form2}>
                <h2 className={styles.secondaryTitle}>{passwordResetTitleContent?.text}</h2>
                <form onSubmit={e => handleReset(e)} autoComplete="off">
                  <label htmlFor="currentPassword" className={styles.labels}>
                    {currentPasswordFieldContent?.text}*
                  </label>
                  <input
                    id="currentPassword"
                    name="currentPassword"
                    onChange={e => setPasswordField2(e.target.value)}
                    type="password"
                    required
                    placeholder={passwordField?.text}
                    className={styles.updateInput}
                    value={passwordField2}
                  />
                  <label htmlFor="newPassword" className={styles.labels}>
                    {newPasswordField?.text}*
                  </label>
                  <input
                    id="newPassword"
                    name="newPassword"
                    onChange={e => setPasswordField3(e.target.value)}
                    type="password"
                    required
                    placeholder={passwordField?.text}
                    autoComplete="none"
                    className={styles.updateInput}
                    value={passwordField3}
                  />
                  <label htmlFor="confirmPassword" className={styles.labels}>
                    {passwordConfirmationField?.text}*
                  </label>
                  <input
                    id="confirmPassword"
                    name="confirmPassword"
                    onChange={e => setPasswordField4(e.target.value)}
                    type="password"
                    required
                    placeholder={passwordField?.text}
                    autoComplete="none"
                    value={passwordField4}
                    className={cn(styles.updateInput, {
                      [styles.inputError]: fieldErrors.passwordConfirm,
                    })}
                  />
                  {fieldErrors.passwordConfirm && (
                    <div className={styles.errorText}>{fieldErrors.passwordConfirm}</div>
                  )}

                  <br />
                  <span className={styles.passwordNotice}>{passwordCaptionContent?.text}</span>
                  <br />
                  <button className={styles.submitButton} type="submit">
                    {buttonTracker2 && (loading || response === false)
                      ? `${updatingPasswordButtonContent?.text}`
                      : `${updatePasswordButtonContent?.text}`}
                  </button>
                  {error && buttonTracker2 && (
                    <div className={styles.mt1}>
                      <span role="img" aria-label="error">
                        ⚠️
                      </span>
                      : {error.message}
                    </div>
                  )}
                </form>
              </div>
            </div>
            <div className={styles.section2}>
              <div className={styles.salon}>
                <h2 className={cn(styles.secondaryTitle, styles.addMargin)}>
                  {salonSectionTitle?.text}
                </h2>
                <span className={styles.description2}>
                  {selectedSalon?.salonName && (
                    <>
                      <strong>{selectedSalon?.salonName}</strong> {selectedSalonContent?.text}
                    </>
                  )}
                  {!selectedSalon?.salonName && noSelectedSalonContent?.text}
                </span>
                <SalonsList
                  globalModules={{ checkout, salonselector }}
                  customClasses={{
                    container: styles.salonListContainer,
                    title: styles.salonListTitle,
                    text: styles.salonListText,
                    buttonSelectSalon: styles.salonListButtonSelectSalon,
                    buttonDeleteSalon: styles.salonListButtonDeleteSalon,
                    buttonStillSelectSalon: styles.salonListButtonStillSelectSalon,
                  }}
                  customCallback={setSelectedSalon}
                  locale={locale}
                />
              </div>
              <div className={styles.deleteAccount}>
                <h2 className={cn(styles.secondaryTitle, styles.addMargin)}>
                  {deleteAccountTitle?.text}
                </h2>
                <span className={styles.description2}>{deleteAccountContent?.text}</span>
                <button
                  className={styles.deleteAccountButton}
                  type="button"
                  onClick={() => setToggleDeleteAccount(true)}
                >
                  {deleteAccountButton?.text}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {toggleDeleteAccount && (
        <DeleteAccount
          customer={customer}
          setToggleDeleteAccount={setToggleDeleteAccount}
          thirdpersonalinfoaccountpage={thirdpersonalinfoaccountpage}
        />
      )}
    </>
  );
};

export default PersonalInfo;
